<template>
  <div style="padding: 20px;">
    <h3>打样/收获信息</h3>
    <tabs 
      :list="aquaticLineFishProofingHarvestInfoDetails" 
      listField="aquaticLineFishProofingHarvestInfoDetails" 
      :head="proofingHead"
      columnsField="proofingColumns"
      dateField="proofingHarvestDate"
      costField="proofingHarvest"
      varietyType='variety2Visible'
    />
    <br>
    <!-- <h3>死鱼信息-第{{ dieActive }}次</h3> -->
    <h3>死鱼信息</h3>
    <tabs
      :noAlert="true"
      @active="changeActive"
      :list="aquaticLineFishDieInfoDetails" 
      listField="aquaticLineFishDieInfoDetails" 
      :head="dieHead"
      columnsField="dieColumns"
      dateField="dieDate"
      costField="die"
      varietyType='variety2Visible'
    />
    <br>
  </div>

</template>

<script>
import Tabs from './Tabs.vue';
import { mapMutations,mapState } from 'vuex';
export default {
  props:['feedVarietyList'],
  components:{ Tabs},
  computed: {
    ...mapState('empirical',[
      'aquaticLineFishProofingHarvestInfoDetails',
      'aquaticLineFishDieInfoDetails',
      'paneType',
      'tabKey',
      'varietyVisible',
      'variety2Visible',
      'varietySelect',
      'aquaticLineFishProofingHarvestInfo',
      'aquaticLineFishDieInfo',
      'varietyDate',
    ]),
  },
  data(){
    return {
      proofingHead: {
        dateTitle: '选择日期',
        dateField: 'proofingHarvestDate',
        varietyTitle: '选择品种',
      },
      dieHead: {
        dateTitle: '选择日期',
        dateField: 'dieDate',
        varietyTitle: '选择品种',
      },
      dieActive: '一',
      numbers: ['一','二','三','四','五','六','七','八','九',],
    }
  },
  watch: {
    variety2Visible(val){
      if(!val){
        setTimeout(() => {
          if(!this[this.paneType][this.tabKey]) this[this.paneType][this.tabKey] = {}
          this[this.paneType][this.tabKey].details = [...this.varietySelect]
          this[this.paneType][this.tabKey][this.dateField] = this.varietyDate
          this.setState({[this.paneType]: [...this[this.paneType]]})
        }, 0);
      }
    },
    aquaticLineFishProofingHarvestInfoDetails: {
      handler(data){
        this.cal(data)
      },
      deep: true
    },
    aquaticLineFishDieInfoDetails: {
      handler(data){
        this.calDieFish(data)
      },
      deep: true
    },
  },
  methods: {
    ...mapMutations('empirical',['setState']),
    changeActive(val){
      this.dieActive = this.numbers[val]
    },
    cal(data){
      let lst = []
        data.forEach(el => {
          if(el) lst = [...lst,...el.details]
        })
        let totalProofingHarvestNum = 0, // 合计打样/收获数量
        totalProofingHarvestWeight = 0, // 合计打样/收获重量
        // totalProofingHarvestVarietyNum = 0, // 合计打样/收获品种数
        // eatFoodProofingHarvestVarietyNum = 0, // 吃食鱼打样/收获品种数
        eatFoodProofingHarvestNum = 0, // 吃食鱼打样/收获数
        eatFoodProofingHarvestWeight = 0, // 吃食鱼打样/收获重量
        // filterFoodProofingHarvestVarietyNum = 0, // 滤食鱼打样/收获品种数
        filterFoodProofingHarvestNum = 0, // 滤食鱼打样/收获数
        filterFoodProofingHarvestWeight = 0, // 滤食鱼打样/收获重量
        varietyIdArr = [],
        csVarietyIdArr = [],
        lsVarietyIdArr = []
        lst.forEach(el => {
          totalProofingHarvestNum += Number(el.proofingHarvestNum || 0)
          totalProofingHarvestWeight += Number(el.proofingHarvestWeight || 0)
          if(!varietyIdArr.includes(el.varietyId)) varietyIdArr.push(el.varietyId)
          if(el.varietyLabelCode === 'chishi') {
            if(!csVarietyIdArr.includes(el.varietyId)) csVarietyIdArr.push(el.varietyId)
            eatFoodProofingHarvestNum += Number(el.proofingHarvestNum || 0)
            eatFoodProofingHarvestWeight += Number(el.proofingHarvestWeight || 0)
          }
          if(el.varietyLabelCode === 'lvshi') {
            if(!lsVarietyIdArr.includes(el.varietyId)) lsVarietyIdArr.push(el.varietyId)
            filterFoodProofingHarvestNum += Number(el.proofingHarvestNum || 0)
            filterFoodProofingHarvestWeight += Number(el.proofingHarvestWeight || 0)
          }
        })
        this.aquaticLineFishProofingHarvestInfo.proofingHarvestTimes = data.length
        this.aquaticLineFishProofingHarvestInfo.totalProofingHarvestNum = totalProofingHarvestNum
        this.aquaticLineFishProofingHarvestInfo.totalProofingHarvestWeight = totalProofingHarvestWeight
        this.aquaticLineFishProofingHarvestInfo.totalProofingHarvestVarietyNum = varietyIdArr.length
        this.aquaticLineFishProofingHarvestInfo.eatFoodProofingHarvestVarietyNum = csVarietyIdArr.length
        this.aquaticLineFishProofingHarvestInfo.eatFoodProofingHarvestNum = eatFoodProofingHarvestNum
        this.aquaticLineFishProofingHarvestInfo.eatFoodProofingHarvestWeight = eatFoodProofingHarvestWeight
        this.aquaticLineFishProofingHarvestInfo.filterFoodProofingHarvestVarietyNum = lsVarietyIdArr.length
        this.aquaticLineFishProofingHarvestInfo.filterFoodProofingHarvestNum = filterFoodProofingHarvestNum
        this.aquaticLineFishProofingHarvestInfo.filterFoodProofingHarvestWeight = filterFoodProofingHarvestWeight
        this.setState({aquaticLineFishProofingHarvestInfo: this.aquaticLineFishProofingHarvestInfo})
    },
    calDieFish(data){
      let lst = []
        data.forEach(el => {
          if(el) lst = [...lst,...el.details]
        })
        let totalDieNum = 0, // 合计死亡数量
        totalDieWeight = 0, // 合计死亡重量
        varietyIdArr = [] // 合计死亡品种数
        lst.forEach(el => {
          totalDieNum += Number(el.dieNum || 0)
          totalDieWeight += Number(el.dieWeight || 0)
          if(!varietyIdArr.includes(el.id)) varietyIdArr.push(el.id)
        })
        this.aquaticLineFishDieInfo.dieTimes = data.length
        this.aquaticLineFishDieInfo.totalDieNum = totalDieNum
        this.aquaticLineFishDieInfo.totalDieWeight = totalDieWeight
        this.aquaticLineFishDieInfo.totalDieVarietyNum = varietyIdArr.length
        this.setState({aquaticLineFishDieInfo: this.aquaticLineFishDieInfo})
    },
  }
}
</script>

<style>

</style>